/**
 * As 27 unidades federativas com conselho regional. **Sem `BR`**: `BR` é o marcador de perfil
 * nacional em `WEB_USUARIO.UF_SOLICITANTE`, não um conselho — escolher "nacional" como conselho não
 * significa nada.
 *
 * <p>Existe porque a mesma lista está hoje duplicada em três telas do app
 * (`usuario-detalhe`, `pesquisa-solicitante` e `relatorio-boletos-emitidos`, esta última com apenas
 * cinco UFs, aparente resto de protótipo). Este arquivo é a versão única; migrar as três é limpeza de
 * outro escopo.</p>
 */
export const UFS_REGIONAIS: ReadonlyArray<{ label: string; value: string }> = ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'].map(
    (sigla) => ({ label: sigla, value: sigla })
);
